export default "__VITE_ASSET__BMWC0ASS__"